import { render, staticRenderFns } from "./DetailMovie.vue?vue&type=template&id=dcbaf3d6&"
import script from "./DetailMovie.vue?vue&type=script&lang=js&"
export * from "./DetailMovie.vue?vue&type=script&lang=js&"
import style0 from "./DetailMovie.vue?vue&type=style&index=0&id=dcbaf3d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports